/* ═══════════════════════════════════════════════════════════
   TEMPLATE « SITE IMMERSIF » — content.js
   ► L'UNIQUE FICHIER À RÉÉCRIRE pour produire un nouveau site.
   Renommer en content.js dans le projet cible. La partie
   « injection » en bas de fichier est le moteur de remplissage :
   la copier TELLE QUELLE, ne réécrire que window.SITE_CONTENT.

   Schéma narratif (rôle de conversion de chaque bloc) :
   1. ACCROCHE       — hook : promesse + identité en 3 secondes
   2. POSITIONNEMENT — positioning : ce que je fais, pour qui, où
   3. DÉMARCHE       — manifesto : pourquoi moi (différenciation)
   4. PREUVE         — proof : réalisations (masonry) OU features (bento)
   5. DEVISE         — motto : 3 mots-clés géants + légendes
   6-7. PROCESSUS    — universes : « X en 3 étapes » + visuels posés
   8. PREUVE SOCIALE — testimonial : un client parle
   9. OBJECTIONS     — objections : « Pas de… Juste… »
   10. CONVERSION    — contact : e-mail + réassurance
   ═══════════════════════════════════════════════════════════ */

/* Textes de la vitrine en 8 langues (généré par /home/user/outils-abobo/vitrine-langues.py).
   La langue est choisie par langues.js (window.SITE_LANG), français par défaut. */
window.SITE_CONTENTS = {
 "fr": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Inventions malines du quotidien",
   "description": "Des inventions utiles au quotidien : coques de téléphone à écran, bracelet santé sans écran et chasse d'eau automatique sans contact.",
   "kicker": "INVENTORIUM-AI — INVENTIONS DU QUOTIDIEN",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "BOUTIQUE ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "AUTRE VITRINE ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODUITS",
   "universes": "COMMANDE",
   "cta": "CONTACT"
  },
  "hook": {
   "line1": "Des inventions malines,",
   "line2a": "pour votre",
   "line2b": "quotidien.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "Une maison intelligente lumineuse avec des écrans connectés",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Des inventions qui simplifient la vie.",
  "manifesto": {
   "text": "Nous choisissons des appareils qui règlent chacun un vrai problème : voir son écran sans le déverrouiller, suivre sa santé sans écran, tirer la chasse sans toucher. Chaque produit fait [[une chose bien]], et nous disons exactement ce qu'il fait."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "LA COLLECTION",
   "title": "Quatre inventions, choisies avec soin",
   "sub": "Coques à écran, bracelet sans écran, chasse d'eau sans contact et nettoyeur de casques de moto.",
   "meta": "IPHONE 13 → 17 PRO MAX — SANTÉ — SALLE DE BAIN — MOTO",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Coque à écran, noire",
     "meta": "IPHONE 17 PRO — COQUE"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "Votre photo au dos",
     "meta": "COQUE IPHONE — ÉCRAN"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Bracelet sans écran",
     "meta": "SANTÉ — BRACELET"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Porté toute la journée",
     "meta": "SANTÉ — SUIVI 24 H"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Coque à écran, orange",
     "meta": "IPHONE 16 PRO — COQUE"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Chasse d'eau sans contact",
     "meta": "SALLE DE BAIN — RECHARGEABLE"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Nettoyeur de casque de moto",
     "meta": "MOTO — ENTRETIEN"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Kit chasse avec détecteur",
     "meta": "SALLE DE BAIN — KIT"
    }
   ]
  },
  "motto": {
   "kicker": "CE QUI GUIDE CHAQUE CHOIX",
   "words": [
    {
     "word": "Utile",
     "hint": "Chaque produit règle un vrai problème du quotidien."
    },
    {
     "word": "Clair",
     "hint": "De vraies photos et des descriptions simples."
    },
    {
     "word": "Honnête",
     "hint": "Prix et délais affichés dès le départ."
    }
   ]
  },
  "universes": {
   "introA": "Une",
   "introB": "commande,",
   "introC": "3 étapes.",
   "cta": "Nous écrire →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Choisir",
     "meta": "ÉTAPE — 01",
     "desc": "Choisissez votre produit et votre option : modèle et couleur de coque, bracelet ou kit de chasse d'eau."
    },
    {
     "name": "Payer en sécurité",
     "meta": "ÉTAPE — 02",
     "desc": "Le paiement passe par Shopify."
    },
    {
     "name": "Recevoir",
     "meta": "ÉTAPE — 03",
     "desc": "Livraison en 10 à 20 jours ouvrés. Les frais de livraison s'affichent au paiement."
    }
   ]
  },
  "testimonial": {
   "kicker": "NOTRE ENGAGEMENT",
   "figure": "",
   "unit": "",
   "quote": "Nous montrons de vraies photos et de vrais prix, et nous ne publierons des avis clients que lorsque de vrais clients les écriront.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "Pas de faux avis.",
    "Pas de fausse urgence.",
    "Pas de jargon."
   ],
   "finale": "Juste des inventions",
   "pill": "utiles."
  },
  "contact": {
   "kicker": "UNE QUESTION ?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "PAIEMENT SÉCURISÉ SHOPIFY — BOUTIQUE SUR INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "en": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Smart Everyday Inventions",
   "description": "Smart inventions for daily life: phone cases with a built-in screen, a screenless health bracelet and a touch-free automatic toilet flush.",
   "kicker": "INVENTORIUM-AI — SMART EVERYDAY INVENTIONS",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "SHOP ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "OTHER SHOWCASE ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODUCTS",
   "universes": "ORDER",
   "cta": "CONTACT"
  },
  "hook": {
   "line1": "Clever technology,",
   "line2a": "for everyday",
   "line2b": "life.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "A bright smart home with connected screens",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Inventions that make daily life easier.",
  "manifesto": {
   "text": "We choose devices that each solve one real problem: seeing your screen without unlocking it, tracking your health without a screen, flushing without touching. Every product does [[one thing well]], and we describe exactly what it does."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "THE COLLECTION",
   "title": "Four inventions, chosen with care",
   "sub": "Screen phone cases, a screenless bracelet, a touch-free flush and a motorcycle helmet cleaner.",
   "meta": "IPHONE 13 → 17 PRO MAX — HEALTH — BATHROOM — MOTORCYCLE",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Screen case, black",
     "meta": "IPHONE 17 PRO — CASE"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "Your photo on the back",
     "meta": "IPHONE CASE — SCREEN"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Screenless bracelet",
     "meta": "HEALTH — BRACELET"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Worn all day",
     "meta": "HEALTH — 24 H TRACKING"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Screen case, orange",
     "meta": "IPHONE 16 PRO — CASE"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Touch-free flush",
     "meta": "BATHROOM — RECHARGEABLE"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Motorcycle helmet cleaner",
     "meta": "MOTORCYCLE — CARE"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Flush kit with sensor",
     "meta": "BATHROOM — KIT"
    }
   ]
  },
  "motto": {
   "kicker": "WHAT GUIDES EVERY CHOICE",
   "words": [
    {
     "word": "Useful",
     "hint": "Each product solves a real, daily problem."
    },
    {
     "word": "Clear",
     "hint": "Real photos and plain descriptions."
    },
    {
     "word": "Honest",
     "hint": "Prices and delivery times shown up front."
    }
   ]
  },
  "universes": {
   "introA": "One",
   "introB": "order,",
   "introC": "3 steps.",
   "cta": "Contact us →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Choose",
     "meta": "STEP — 01",
     "desc": "Pick your product and option: case model and colour, bracelet, or flush kit."
    },
    {
     "name": "Pay securely",
     "meta": "STEP — 02",
     "desc": "Checkout is handled by Shopify."
    },
    {
     "name": "Receive",
     "meta": "STEP — 03",
     "desc": "Delivery in 10 to 20 business days. Shipping fees are shown at checkout."
    }
   ]
  },
  "testimonial": {
   "kicker": "OUR COMMITMENT",
   "figure": "",
   "unit": "",
   "quote": "We show real photos and real prices, and we will publish customer reviews only when real customers write them.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "No fake reviews.",
    "No false urgency.",
    "No jargon."
   ],
   "finale": "Just useful",
   "pill": "inventions."
  },
  "contact": {
   "kicker": "A QUESTION?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "SECURE SHOPIFY CHECKOUT — SHOP AT INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "es": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Inventos inteligentes para el día a día",
   "description": "Inventos útiles para el día a día: fundas de móvil con pantalla, pulsera de salud sin pantalla y descarga automática del inodoro sin contacto.",
   "kicker": "INVENTORIUM-AI — INVENTOS DEL DÍA A DÍA",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "TIENDA ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "OTRO ESCAPARATE ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODUCTOS",
   "universes": "PEDIDO",
   "cta": "CONTACTO"
  },
  "hook": {
   "line1": "Inventos inteligentes,",
   "line2a": "para tu",
   "line2b": "día a día.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "Una casa inteligente luminosa con pantallas conectadas",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Inventos que hacen la vida más fácil.",
  "manifesto": {
   "text": "Elegimos aparatos que resuelven cada uno un problema real: ver la pantalla sin desbloquear el móvil, controlar la salud sin pantalla, tirar de la cadena sin tocar. Cada producto hace [[una cosa bien]], y explicamos exactamente lo que hace."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "LA COLECCIÓN",
   "title": "Cuatro inventos, elegidos con cuidado",
   "sub": "Fundas con pantalla, una pulsera sin pantalla, una descarga sin contacto y un limpiador de cascos de moto.",
   "meta": "IPHONE 13 → 17 PRO MAX — SALUD — BAÑO — MOTO",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Funda con pantalla, negra",
     "meta": "IPHONE 17 PRO — FUNDA"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "Tu foto en la parte trasera",
     "meta": "FUNDA IPHONE — PANTALLA"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Pulsera sin pantalla",
     "meta": "SALUD — PULSERA"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Para llevar todo el día",
     "meta": "SALUD — SEGUIMIENTO 24 H"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Funda con pantalla, naranja",
     "meta": "IPHONE 16 PRO — FUNDA"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Descarga sin contacto",
     "meta": "BAÑO — RECARGABLE"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Limpiador de cascos de moto",
     "meta": "MOTO — LIMPIEZA"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Kit de descarga con sensor",
     "meta": "BAÑO — KIT"
    }
   ]
  },
  "motto": {
   "kicker": "LO QUE GUÍA CADA ELECCIÓN",
   "words": [
    {
     "word": "Útil",
     "hint": "Cada producto resuelve un problema real del día a día."
    },
    {
     "word": "Claro",
     "hint": "Fotos reales y descripciones sencillas."
    },
    {
     "word": "Honesto",
     "hint": "Precios y plazos visibles desde el principio."
    }
   ]
  },
  "universes": {
   "introA": "Un",
   "introB": "pedido,",
   "introC": "3 pasos.",
   "cta": "Escríbenos →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Elegir",
     "meta": "PASO — 01",
     "desc": "Elige tu producto y tu opción: modelo y color de la funda, pulsera o kit de descarga."
    },
    {
     "name": "Pagar con seguridad",
     "meta": "PASO — 02",
     "desc": "El pago lo gestiona Shopify."
    },
    {
     "name": "Recibir",
     "meta": "PASO — 03",
     "desc": "Entrega en 10 a 20 días hábiles. Los gastos de envío se muestran al pagar."
    }
   ]
  },
  "testimonial": {
   "kicker": "NUESTRO COMPROMISO",
   "figure": "",
   "unit": "",
   "quote": "Mostramos fotos reales y precios reales, y solo publicaremos opiniones de clientes cuando clientes reales las escriban.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "Sin opiniones falsas.",
    "Sin falsas urgencias.",
    "Sin jerga."
   ],
   "finale": "Solo inventos",
   "pill": "útiles."
  },
  "contact": {
   "kicker": "¿UNA PREGUNTA?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "PAGO SEGURO CON SHOPIFY — TIENDA EN INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "de": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Clevere Erfindungen für den Alltag",
   "description": "Nützliche Erfindungen für den Alltag: Handyhüllen mit Display, ein Gesundheitsarmband ohne Display und eine berührungslose automatische Toilettenspülung.",
   "kicker": "INVENTORIUM-AI — ERFINDUNGEN FÜR DEN ALLTAG",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "SHOP ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "OTHER SHOWCASE ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODUKTE",
   "universes": "BESTELLUNG",
   "cta": "KONTAKT"
  },
  "hook": {
   "line1": "Clevere Erfindungen,",
   "line2a": "für Ihren",
   "line2b": "Alltag.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "Ein helles Smart Home mit vernetzten Bildschirmen",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Erfindungen, die den Alltag erleichtern.",
  "manifesto": {
   "text": "Wir wählen Geräte, die jeweils ein echtes Problem lösen: den Bildschirm sehen, ohne zu entsperren, die Gesundheit ohne Display verfolgen, spülen ohne Berührung. Jedes Produkt macht [[eine Sache gut]], und wir beschreiben genau, was es kann."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "DIE KOLLEKTION",
   "title": "Vier Erfindungen, sorgfältig ausgewählt",
   "sub": "Hüllen mit Display, ein Armband ohne Display, eine berührungslose Spülung und ein Motorradhelm-Reiniger.",
   "meta": "IPHONE 13 → 17 PRO MAX — GESUNDHEIT — BAD — MOTORRAD",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Hülle mit Display, schwarz",
     "meta": "IPHONE 17 PRO — HÜLLE"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "Ihr Foto auf der Rückseite",
     "meta": "IPHONE-HÜLLE — DISPLAY"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Armband ohne Display",
     "meta": "GESUNDHEIT — ARMBAND"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Den ganzen Tag getragen",
     "meta": "GESUNDHEIT — 24-H-TRACKING"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Hülle mit Display, orange",
     "meta": "IPHONE 16 PRO — HÜLLE"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Berührungslose Spülung",
     "meta": "BAD — WIEDERAUFLADBAR"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Motorradhelm-Reiniger",
     "meta": "MOTORRAD — PFLEGE"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Spül-Set mit Sensor",
     "meta": "BAD — SET"
    }
   ]
  },
  "motto": {
   "kicker": "WAS JEDE AUSWAHL LEITET",
   "words": [
    {
     "word": "Nützlich",
     "hint": "Jedes Produkt löst ein echtes Alltagsproblem."
    },
    {
     "word": "Klar",
     "hint": "Echte Fotos und einfache Beschreibungen."
    },
    {
     "word": "Ehrlich",
     "hint": "Preise und Lieferzeiten von Anfang an sichtbar."
    }
   ]
  },
  "universes": {
   "introA": "Eine",
   "introB": "Bestellung,",
   "introC": "3 Schritte.",
   "cta": "Schreiben Sie uns →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Auswählen",
     "meta": "SCHRITT — 01",
     "desc": "Wählen Sie Produkt und Option: Modell und Farbe der Hülle, Armband oder Spül-Set."
    },
    {
     "name": "Sicher bezahlen",
     "meta": "SCHRITT — 02",
     "desc": "Die Zahlung läuft über Shopify."
    },
    {
     "name": "Erhalten",
     "meta": "SCHRITT — 03",
     "desc": "Lieferung in 10 bis 20 Werktagen. Die Versandkosten werden an der Kasse angezeigt."
    }
   ]
  },
  "testimonial": {
   "kicker": "UNSER VERSPRECHEN",
   "figure": "",
   "unit": "",
   "quote": "Wir zeigen echte Fotos und echte Preise und veröffentlichen Kundenbewertungen erst, wenn echte Kunden sie schreiben.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "Keine gefälschten Bewertungen.",
    "Keine falsche Eile.",
    "Kein Fachjargon."
   ],
   "finale": "Nur nützliche",
   "pill": "Erfindungen."
  },
  "contact": {
   "kicker": "EINE FRAGE?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "SICHERE ZAHLUNG MIT SHOPIFY — SHOP AUF INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "it": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Invenzioni intelligenti per ogni giorno",
   "description": "Invenzioni utili per ogni giorno: cover per telefono con schermo, braccialetto per la salute senza schermo e scarico automatico del WC senza contatto.",
   "kicker": "INVENTORIUM-AI — INVENZIONI PER OGNI GIORNO",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "NEGOZIO ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "ALTRA VETRINA ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODOTTI",
   "universes": "ORDINE",
   "cta": "CONTATTO"
  },
  "hook": {
   "line1": "Invenzioni intelligenti,",
   "line2a": "per ogni",
   "line2b": "giorno.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "Una casa intelligente luminosa con schermi connessi",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Invenzioni che semplificano la vita.",
  "manifesto": {
   "text": "Scegliamo dispositivi che risolvono ciascuno un problema reale: vedere lo schermo senza sbloccare il telefono, monitorare la salute senza schermo, scaricare il WC senza toccarlo. Ogni prodotto fa [[una cosa bene]], e spieghiamo esattamente cosa fa."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "LA COLLEZIONE",
   "title": "Quattro invenzioni, scelte con cura",
   "sub": "Cover con schermo, un braccialetto senza schermo, uno scarico senza contatto e un pulitore per caschi da moto.",
   "meta": "IPHONE 13 → 17 PRO MAX — SALUTE — BAGNO — MOTO",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Cover con schermo, nera",
     "meta": "IPHONE 17 PRO — COVER"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "La tua foto sul retro",
     "meta": "COVER IPHONE — SCHERMO"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Braccialetto senza schermo",
     "meta": "SALUTE — BRACCIALETTO"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Da indossare tutto il giorno",
     "meta": "SALUTE — MONITORAGGIO 24 H"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Cover con schermo, arancione",
     "meta": "IPHONE 16 PRO — COVER"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Scarico senza contatto",
     "meta": "BAGNO — RICARICABILE"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Pulitore per caschi da moto",
     "meta": "MOTO — PULIZIA"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Kit scarico con sensore",
     "meta": "BAGNO — KIT"
    }
   ]
  },
  "motto": {
   "kicker": "CIÒ CHE GUIDA OGNI SCELTA",
   "words": [
    {
     "word": "Utile",
     "hint": "Ogni prodotto risolve un vero problema quotidiano."
    },
    {
     "word": "Chiaro",
     "hint": "Foto reali e descrizioni semplici."
    },
    {
     "word": "Onesto",
     "hint": "Prezzi e tempi di consegna visibili fin dall'inizio."
    }
   ]
  },
  "universes": {
   "introA": "Un",
   "introB": "ordine,",
   "introC": "3 passi.",
   "cta": "Scrivici →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Scegliere",
     "meta": "PASSO — 01",
     "desc": "Scegli il prodotto e l'opzione: modello e colore della cover, braccialetto o kit di scarico."
    },
    {
     "name": "Pagare in sicurezza",
     "meta": "PASSO — 02",
     "desc": "Il pagamento è gestito da Shopify."
    },
    {
     "name": "Ricevere",
     "meta": "PASSO — 03",
     "desc": "Consegna in 10–20 giorni lavorativi. Le spese di spedizione sono indicate al pagamento."
    }
   ]
  },
  "testimonial": {
   "kicker": "IL NOSTRO IMPEGNO",
   "figure": "",
   "unit": "",
   "quote": "Mostriamo foto reali e prezzi reali, e pubblicheremo recensioni solo quando le scriveranno clienti veri.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "Niente recensioni false.",
    "Niente false urgenze.",
    "Niente gergo."
   ],
   "finale": "Solo invenzioni",
   "pill": "utili."
  },
  "contact": {
   "kicker": "UNA DOMANDA?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "PAGAMENTO SICURO CON SHOPIFY — NEGOZIO SU INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "pt": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — Invenções inteligentes para o dia a dia",
   "description": "Invenções úteis para o dia a dia: capas de telemóvel com ecrã, pulseira de saúde sem ecrã e autoclismo automático sem contacto.",
   "kicker": "INVENTORIUM-AI — INVENÇÕES PARA O DIA A DIA",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "LOJA ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "OUTRA VITRINE ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "PRODUTOS",
   "universes": "ENCOMENDA",
   "cta": "CONTACTO"
  },
  "hook": {
   "line1": "Invenções inteligentes,",
   "line2a": "para o seu",
   "line2b": "dia a dia.",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "Uma casa inteligente luminosa com ecrãs ligados",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "Invenções que facilitam o dia a dia.",
  "manifesto": {
   "text": "Escolhemos aparelhos que resolvem, cada um, um problema real: ver o ecrã sem desbloquear o telemóvel, acompanhar a saúde sem ecrã, puxar o autoclismo sem tocar. Cada produto faz [[uma coisa bem]], e explicamos exatamente o que faz."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "A COLEÇÃO",
   "title": "Quatro invenções, escolhidas com cuidado",
   "sub": "Capas com ecrã, uma pulseira sem ecrã, um autoclismo sem contacto e um limpador de capacetes de mota.",
   "meta": "IPHONE 13 → 17 PRO MAX — SAÚDE — CASA DE BANHO — MOTA",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "Capa com ecrã, preta",
     "meta": "IPHONE 17 PRO — CAPA"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "A sua foto nas costas",
     "meta": "CAPA IPHONE — ECRÃ"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "Pulseira sem ecrã",
     "meta": "SAÚDE — PULSEIRA"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "Usada o dia todo",
     "meta": "SAÚDE — MONITORIZAÇÃO 24 H"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "Capa com ecrã, laranja",
     "meta": "IPHONE 16 PRO — CAPA"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "Autoclismo sem contacto",
     "meta": "CASA DE BANHO — RECARREGÁVEL"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "Limpador de capacetes de mota",
     "meta": "MOTA — LIMPEZA"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "Kit de autoclismo com sensor",
     "meta": "CASA DE BANHO — KIT"
    }
   ]
  },
  "motto": {
   "kicker": "O QUE GUIA CADA ESCOLHA",
   "words": [
    {
     "word": "Útil",
     "hint": "Cada produto resolve um problema real do dia a dia."
    },
    {
     "word": "Claro",
     "hint": "Fotos reais e descrições simples."
    },
    {
     "word": "Honesto",
     "hint": "Preços e prazos visíveis desde o início."
    }
   ]
  },
  "universes": {
   "introA": "Uma",
   "introB": "encomenda,",
   "introC": "3 passos.",
   "cta": "Escreva-nos →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "Escolher",
     "meta": "PASSO — 01",
     "desc": "Escolha o produto e a opção: modelo e cor da capa, pulseira ou kit de autoclismo."
    },
    {
     "name": "Pagar em segurança",
     "meta": "PASSO — 02",
     "desc": "O pagamento é feito pela Shopify."
    },
    {
     "name": "Receber",
     "meta": "PASSO — 03",
     "desc": "Entrega em 10 a 20 dias úteis. Os portes são indicados no pagamento."
    }
   ]
  },
  "testimonial": {
   "kicker": "O NOSSO COMPROMISSO",
   "figure": "",
   "unit": "",
   "quote": "Mostramos fotos reais e preços reais, e só publicaremos opiniões de clientes quando clientes reais as escreverem.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "Sem opiniões falsas.",
    "Sem falsa urgência.",
    "Sem jargão."
   ],
   "finale": "Apenas invenções",
   "pill": "úteis."
  },
  "contact": {
   "kicker": "UMA PERGUNTA?",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "PAGAMENTO SEGURO COM SHOPIFY — LOJA EM INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "ar": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — اختراعات ذكية للحياة اليومية",
   "description": "اختراعات مفيدة للحياة اليومية: أغطية هواتف بشاشة، وسوار صحي بلا شاشة، وسيفون تلقائي يعمل بدون لمس.",
   "kicker": "INVENTORIUM-AI — اختراعات للحياة اليومية",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "المتجر ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "واجهة أخرى ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "المنتجات",
   "universes": "الطلب",
   "cta": "تواصل"
  },
  "hook": {
   "line1": "اختراعات ذكية،",
   "line2a": "لحياتك",
   "line2b": "اليومية",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "منزل ذكي مضيء بشاشات متصلة",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "اختراعات تجعل الحياة اليومية أسهل.",
  "manifesto": {
   "text": "نختار أجهزة يحل كل منها مشكلة حقيقية: رؤية الشاشة دون فتح الهاتف، ومتابعة الصحة دون شاشة، وتشغيل السيفون دون لمس. كل منتج يتقن [[شيئًا واحدًا]]، ونشرح بدقة ما يفعله."
  },
  "proof": {
   "layout": "masonry",
   "kicker": "المجموعة",
   "title": "أربعة اختراعات مختارة بعناية",
   "sub": "أغطية بشاشة، وسوار بلا شاشة، وسيفون بدون لمس، ومنظف لخوذ الدراجات النارية.",
   "meta": "IPHONE 13 → 17 PRO MAX — الصحة — الحمّام — الدراجات النارية",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "غطاء بشاشة، أسود",
     "meta": "IPHONE 17 PRO — غطاء"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "صورتك على الظهر",
     "meta": "غطاء IPHONE — شاشة"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "سوار بلا شاشة",
     "meta": "الصحة — سوار"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "يُلبس طوال اليوم",
     "meta": "الصحة — متابعة 24 ساعة"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "غطاء بشاشة، برتقالي",
     "meta": "IPHONE 16 PRO — غطاء"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "سيفون بدون لمس",
     "meta": "الحمّام — قابل للشحن"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "منظف خوذ الدراجات النارية",
     "meta": "الدراجات النارية — العناية"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "طقم سيفون مع مستشعر",
     "meta": "الحمّام — طقم"
    }
   ]
  },
  "motto": {
   "kicker": "ما يوجّه كل اختيار",
   "words": [
    {
     "word": "مفيد",
     "hint": "كل منتج يحل مشكلة يومية حقيقية."
    },
    {
     "word": "واضح",
     "hint": "صور حقيقية ووصف بسيط."
    },
    {
     "word": "صادق",
     "hint": "الأسعار ومدة التوصيل معروضة من البداية."
    }
   ]
  },
  "universes": {
   "introA": "طلب",
   "introB": "واحد",
   "introC": "3 خطوات",
   "cta": "راسلنا ←",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "اختر",
     "meta": "الخطوة — 01",
     "desc": "اختر المنتج والخيار: طراز الغطاء ولونه، أو السوار، أو طقم السيفون."
    },
    {
     "name": "ادفع بأمان",
     "meta": "الخطوة — 02",
     "desc": "تتم عملية الدفع عبر Shopify."
    },
    {
     "name": "استلم",
     "meta": "الخطوة — 03",
     "desc": "التوصيل خلال 10 إلى 20 يوم عمل. تظهر رسوم الشحن عند الدفع."
    }
   ]
  },
  "testimonial": {
   "kicker": "التزامنا",
   "figure": "",
   "unit": "",
   "quote": "نعرض صورًا حقيقية وأسعارًا حقيقية، ولن ننشر آراء العملاء إلا عندما يكتبها عملاء حقيقيون.",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "لا آراء مزيفة.",
    "لا استعجال مصطنع.",
    "لا مصطلحات معقدة."
   ],
   "finale": "فقط اختراعات",
   "pill": "مفيدة."
  },
  "contact": {
   "kicker": "لديك سؤال؟",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "دفع آمن عبر SHOPIFY — المتجر على INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 },
 "zh": {
  "brand": {
   "name": "INVENTORIUM-AI",
   "title": "INVENTORIUM-AI — 日常智能小发明",
   "description": "实用的日常发明：带屏幕的手机壳、无屏健康手环和免接触自动冲水器。",
   "kicker": "INVENTORIUM-AI — 日常智能发明",
   "copyright": "© 2026 INVENTORIUM-AI",
   "signature": "EST. 2026",
   "socials": [
    {
     "label": "商店 ↗",
     "url": "https://inventorium-ai.com"
    },
    {
     "label": "另一个橱窗 ↗",
     "url": "https://claude.ai/artifact/N2zXcgbDDWpqMHyrTfXcY4"
    }
   ]
  },
  "nav": {
   "proof": "产品",
   "universes": "下单",
   "cta": "联系"
  },
  "hook": {
   "line1": "智能小发明，",
   "line2a": "让日常",
   "line2b": "更轻松。",
   "image": VIMG("images/hero.jpg"),
   "imageAlt": "明亮的智能家居，配有联网屏幕",
   "floaters": [
    VIMG("images/f1.jpg"),
    VIMG("images/f2.jpg"),
    VIMG("images/f3.jpg"),
    VIMG("images/f4.jpg"),
    VIMG("images/f5.jpg"),
    VIMG("images/f6.jpg"),
    VIMG("images/f7.jpg"),
    VIMG("images/f8.jpg"),
    VIMG("images/f9.jpg"),
    VIMG("images/f10.jpg")
   ]
  },
  "positioning": "让日常生活 更轻松的发明。",
  "manifesto": {
   "text": "我们挑选的每件设备， 都解决一个真实问题： 不解锁也能看屏幕， 没有屏幕也能关注健康， 不用触碰就能冲水。 每件产品都[[专注一件事]]， 我们如实说明它的功能。"
  },
  "proof": {
   "layout": "masonry",
   "kicker": "产品系列",
   "title": "精心挑选的四款发明",
   "sub": "屏幕手机壳、无屏手环、免接触冲水器和摩托车头盔清洁机。",
   "meta": "IPHONE 13 → 17 PRO MAX — 健康 — 浴室 — 摩托车",
   "projects": [
    {
     "img": VIMG("images/p1.jpg"),
     "title": "屏幕手机壳，黑色",
     "meta": "IPHONE 17 PRO — 手机壳"
    },
    {
     "img": VIMG("images/p2.jpg"),
     "title": "背面显示你的照片",
     "meta": "IPHONE 手机壳 — 屏幕"
    },
    {
     "img": VIMG("images/p3.jpg"),
     "title": "无屏手环",
     "meta": "健康 — 手环"
    },
    {
     "img": VIMG("images/p4.jpg"),
     "title": "全天佩戴",
     "meta": "健康 — 24 小时监测"
    },
    {
     "img": VIMG("images/p5.jpg"),
     "title": "屏幕手机壳，橙色",
     "meta": "IPHONE 16 PRO — 手机壳"
    },
    {
     "img": VIMG("images/p6.jpg"),
     "title": "免接触冲水",
     "meta": "浴室 — 可充电"
    },
    {
     "img": VIMG("images/p9.jpg"),
     "title": "摩托车头盔清洁机",
     "meta": "摩托车 — 清洁"
    },
    {
     "img": VIMG("images/p8.jpg"),
     "title": "带感应器的冲水套装",
     "meta": "浴室 — 套装"
    }
   ]
  },
  "motto": {
   "kicker": "每个选择的原则",
   "words": [
    {
     "word": "实用",
     "hint": "每件产品都解决一个真实的日常问题。"
    },
    {
     "word": "清楚",
     "hint": "真实照片，简单说明。"
    },
    {
     "word": "诚实",
     "hint": "价格和配送时间一开始就清楚标明。"
    }
   ]
  },
  "universes": {
   "introA": "一个",
   "introB": "订单，",
   "introC": "3 步。",
   "cta": "联系我们 →",
   "image": VIMG("images/process.jpg"),
   "items": [
    {
     "name": "选择",
     "meta": "步骤 — 01",
     "desc": "选择产品和选项：手机壳型号和颜色、手环或冲水套装。"
    },
    {
     "name": "安全付款",
     "meta": "步骤 — 02",
     "desc": "付款由 Shopify 处理。"
    },
    {
     "name": "收货",
     "meta": "步骤 — 03",
     "desc": "10 至 20 个工作日送达。运费在结账时显示。"
    }
   ]
  },
  "testimonial": {
   "kicker": "我们的承诺",
   "figure": "",
   "unit": "",
   "quote": "我们展示真实的照片和真实的价格，只有当真实顾客写下评价时，我们才会发布顾客评价。",
   "author": "INVENTORIUM-AI"
  },
  "objections": {
   "items": [
    "没有虚假评价。",
    "没有虚假紧迫感。",
    "没有行话。"
   ],
   "finale": "只有实用的",
   "pill": "发明。"
  },
  "contact": {
   "kicker": "有问题吗？",
   "email": "inventorium.ai@gmail.com",
   "reassurance": "SHOPIFY 安全付款 — 商店：INVENTORIUM-AI.COM"
  },
  "trail": [
   VIMG("images/t1.jpg"),
   VIMG("images/t2.jpg"),
   VIMG("images/t3.jpg"),
   VIMG("images/t4.jpg"),
   VIMG("images/t5.jpg"),
   VIMG("images/t6.jpg"),
   VIMG("images/t7.jpg"),
   VIMG("images/t8.jpg"),
   VIMG("images/t9.jpg"),
   VIMG("images/t10.jpg"),
   VIMG("images/t11.jpg"),
   VIMG("images/t12.jpg"),
   VIMG("images/t13.jpg"),
   VIMG("images/t14.jpg"),
   VIMG("images/t15.jpg"),
   VIMG("images/t16.jpg"),
   VIMG("images/t17.jpg"),
   VIMG("images/t18.jpg"),
   VIMG("images/t19.jpg"),
   VIMG("images/t20.jpg")
  ]
 }
};
window.SITE_CONTENT = window.SITE_CONTENTS[window.SITE_LANG] || window.SITE_CONTENTS.fr;

/* ═══════════════════════════════════════════════════════════
   INJECTION — NE PAS MODIFIER (remplit le DOM avant app.js)
   ═══════════════════════════════════════════════════════════ */
(() => {
  const C = window.SITE_CONTENT;
  const $ = (s) => document.querySelector(s);
  const $$ = (s) => [...document.querySelectorAll(s)];
  const set = (sel, txt) => { const el = $(sel); if (el) el.textContent = txt; };

  document.title = C.brand.title;
  const md = document.querySelector('meta[name="description"]');
  if (md) md.setAttribute('content', C.brand.description);

  // chrome
  set('.loader-wordmark', C.brand.name);
  set('.dock-wordmark', C.brand.name);
  set('.dock-link[href="#travaux"]', C.nav.proof);
  set('.dock-link[href="#explorer"]', C.nav.universes);
  set('.dock-cta', C.nav.cta);

  // 1 · accroche
  set('#heroKicker', C.brand.kicker);
  set('#heroLine1', C.hook.line1);
  const hls = $$('#heroLine2 .hl');
  if (hls.length === 2) { hls[0].textContent = C.hook.line2a; hls[1].textContent = C.hook.line2b; }
  const g1 = $('#grow1 img');
  if (g1) { g1.src = C.hook.image; g1.alt = C.hook.imageAlt; }
  $$('.floaters .fl img').forEach((img, i) => { if (C.hook.floaters[i]) img.src = C.hook.floaters[i]; });

  // 2 · positionnement (un span par mot)
  const intro = $('#spotIntro');
  if (intro) intro.innerHTML = C.positioning.split(' ').map((w) => `<span>${w}</span>`).join(' ');

  // 3 · démarche
  const fill = $('#fillText');
  if (fill) {
    fill.innerHTML = C.manifesto.text.replace(
      /\[\[(.+?)\]\]/,
      '<span class="boxed" id="boxedPhrase">$1<svg class="box-svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path id="boxPath" d="M50,6 C88,4 98,22 97,50 C96,82 76,96 49,95 C16,94 3,76 4,48 C5,18 20,7 50,6 Z"/></svg></span>'
    );
  }

  // 4 · preuve : masonry (8 photos) ou bento (4 features big/tall/tall/big)
  const head = $$('.coll-head > *');
  if (head.length === 4) {
    head[0].textContent = C.proof.kicker;
    head[1].textContent = C.proof.title;
    head[2].textContent = C.proof.sub;
    head[3].textContent = C.proof.meta;
  }
  const grid = $('#collGrid');
  if (grid && C.proof.layout === 'bento') {
    grid.className = 'bento-grid';
    grid.innerHTML = C.proof.features.map((f) =>
      `<figure class="card${f.size ? ' b-' + f.size : ''}"><div class="card-img"><img src="${f.illu}" alt="${f.title}"></div><figcaption>${f.title}<span class="mono">${f.meta}</span></figcaption></figure>`
    ).join('');
  } else if (grid) {
    grid.className = 'coll-grid';
    const SPEEDS = [-0.05, 0.06, -0.028, 0.085];
    grid.innerHTML = SPEEDS.map((s, ci) =>
      `<div class="col" data-pspeed="${s}">` +
      C.proof.projects.slice(ci * 2, ci * 2 + 2).map((p) =>
        `<figure class="card"><div class="card-img"><img src="${p.img}" alt="${p.title} — ${p.meta}"></div><figcaption>${p.title}<span class="mono">${p.meta}</span></figcaption></figure>`
      ).join('') + '</div>'
    ).join('');
  }

  // 5 · devise (train de mots-clés)
  set('#mottoKicker', C.motto.kicker);
  const mtrack = $('#mottoTrack');
  if (mtrack) mtrack.innerHTML = C.motto.words.map((w) => `<span class="mw">${w.word}</span>`).join('');

  // 6-7 · processus immersif (visuels posés un à un)
  set('#nw1', C.universes.introA);
  set('#nw2', C.universes.introB);
  set('#nw3', C.universes.introC);
  const g2 = $('#grow2 img');
  if (g2) g2.src = C.universes.image || (C.universes.items[0] || {}).img || g2.src;
  const psteps = $('#psteps');
  if (psteps) {
    psteps.innerHTML = C.universes.items.map((u) =>
      `<div class="pstep"><span class="pstep-meta mono ash">${u.meta}</span><h3>${u.name}</h3><p>${u.desc || ''}</p></div>`
    ).join('');
  }
  const sCta = $('#stepsCtaLink');
  if (sCta) sCta.childNodes[0].textContent = C.universes.cta;

  // 8 · preuve sociale — le chiffre qui frappe
  set('#figKicker', C.testimonial.kicker || '');
  const figM = String(C.testimonial.figure || '').trim().match(/^([^\d.,+-]*[+\u2212-]?)\s*(-?[\d.,]+)/);
  set('#figPre', figM ? figM[1] : '');
  set('#figVal', figM ? figM[2] : '');
  set('#figUnit', C.testimonial.unit || '');
  set('#quoteText', C.testimonial.quote);
  set('#quoteAuthor', C.testimonial.author);

  // 9 · objections
  C.objections.items.forEach((t, i) => set('#fs' + (i + 1), t));
  const fs4 = $('#fs4');
  if (fs4) {
    fs4.innerHTML = `${C.objections.finale} <span class="pill" id="pillPhrase">${C.objections.pill}<svg class="pill-svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path id="pillPath" d="M50,6 C88,4 98,22 97,50 C96,82 76,96 49,95 C16,94 3,76 4,48 C5,18 20,7 50,6 Z"/></svg></span>`;
  }
  $$('#trail img').forEach((img, i) => { img.src = C.trail[i % C.trail.length]; });

  // 10 · conversion
  set('.footer-kicker', C.contact.kicker);
  const mail = $('.footer-mail');
  if (mail) { mail.href = 'mailto:' + C.contact.email; mail.querySelector('.footer-mail-text').textContent = C.contact.email; }
  set('.footer-reassurance', C.contact.reassurance);
  const fname = $('#footerName');
  if (fname) { fname.textContent = C.brand.name; fname.setAttribute('aria-label', C.brand.name); }
  const bottom = $$('.footer-bottom > p');
  if (bottom.length === 3) {
    bottom[0].textContent = C.brand.copyright;
    bottom[1].innerHTML = C.brand.socials.map((s) => `<a href="${s.url}" target="_blank" rel="noopener">${s.label}</a>`).join('&nbsp;&nbsp;&nbsp;');
    bottom[2].textContent = C.brand.signature;
  }
})();
